export default "__VITE_ASSET__256efd07__"